
import Rtl from './theme_config/RTL'
import MainLayout from './theme_config/layout/layout1'
import MainProvider from './context/providerContext/MainProvider'
function App() {
  return (
    <MainProvider>

      <Rtl>
        <div className="App">
          <MainLayout />
        </div>
      </Rtl>
    </MainProvider>

  );
}

export default App;



